/**
 * デモ配列（I14 相当）。ファイルが無くても作業面をすぐ確かめられるようにする。
 * 222 bp 環状。原点をまたぐ CDS を含め、環状ラップ表示の確認にも使う。
 */

const DEMO_BASES = [
  'GAATTCACGTTTGGGCCCAAATTTGGGCCCAAATTTGGGCCCAAATTTGG',
  'GGATCCTTACGCATGCATGCATGCATTTACGCATGCATTGGGCCCAAATT',
  'ACGTACGTAAGGCCTTAAGGCCTTAAGGCCTTAAGGCCTTAAGGCCTTAA',
  'TTTAGGGCCCTTTAAAGGGCCCTTTAAAGGGCCCTTTAAAGGGCCCTTTA',
  'ATGCGTAAAGGCGAAGAGCTGTTCACTGGTGTCGTCCCTATTCTGGTGGA',
].join('');

const DEMO_SEQUENCE = DEMO_BASES.slice(0, 222);

function originLines(sequence: string): string {
  const lines: string[] = [];
  for (let offset = 0; offset < sequence.length; offset += 60) {
    const row = sequence.slice(offset, offset + 60);
    const groups: string[] = [];
    for (let i = 0; i < row.length; i += 10) groups.push(row.slice(i, i + 10).toLowerCase());
    lines.push(`${String(offset + 1).padStart(9, ' ')} ${groups.join(' ')}`);
  }
  return lines.join('\n');
}

export const DEMO_GENBANK_TEXT = `LOCUS       demo-sites-crispr        222 bp    DNA     circular SYN 30-AUG-2026
DEFINITION  研助 遺伝子解析のデモ配列（環状 222 bp・原点ラップ CDS 入り）.
ACCESSION   demo-sites-crispr
FEATURES             Location/Qualifiers
     source          1..222
                     /organism="synthetic construct"
     misc_feature    1..6
                     /label="EcoRI"
     misc_feature    51..56
                     /label="BamHI"
     gene            101..160
                     /gene="demoR"
     CDS             join(201..222,1..40)
                     /locus_tag="wrapCDS"
                     /product="origin spanning demo CDS"
     promoter        complement(161..190)
                     /label="Pdemo"
ORIGIN
${originLines(DEMO_SEQUENCE)}
//
`;

export const DEMO_FILE_NAME = 'demo-sites-crispr.gb';

export function createDemoSequenceFile(): File {
  return new File([DEMO_GENBANK_TEXT], DEMO_FILE_NAME, { type: 'text/plain' });
}
